import type { WrapperFC } from '@george-labs.com/design-system';
import { Button, StripeActionButton } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

import type { BankMessage } from '../BankMessagesTypes';
import { isBankMessageDeletable, isBankMessageUnread } from '../BankMessagesService';

interface Props {
    message: BankMessage | undefined;
    onClick(): void;
}

export const BankMessageDeleteButton: WrapperFC<Props> = ({ message, onClick }) => {
    if (!message || isBankMessageUnread(message.flags) || !isBankMessageDeletable(message.flags)) {
        return null;
    }

    return (
        <StripeActionButton
            icon={Button.ICON.DELETE}
            data-cy="delete-bank-message"
            onClick={onClick}
        >
            {t('bankMessages.details.deleteMessageBtn')}
        </StripeActionButton>
    );
};

BankMessageDeleteButton.wrapsComponent = StripeActionButton;
